export const optimizationSets = {
    "AVERAGE TOTAL BALANCE": {
        title: "Optimize average total balance",
        description: "These resources will help your employees optimize their average total balance over time.",
        leftTile: {
            title: "HSA Savings Calculator",
            description: "Discover how much money you can save with an HSA!",
            icon: "fa-solid fa-calculator",
            url: "https://www.hsabank.com/hsabank/employer-resources/tools/HSA-savings-calculator"
        },
        rightTile: {
            title: "Additional resources",
            description: "Support your employees with additional resources that answer questions and optimize savings.",
            icon: "fa-solid fa-arrow-up-right-from-square",
            url: "https://www.hsabank.com/hsabank/partner-sites/open-enrollment/additional-resources"
        }
    },
    "ZERO DOLLAR ACCOUNTS": {
        title: "Optimize zero dollar accounts",
        description: "These resources will help your employees take advantage of savings opportunities over time.",
        leftTile: {
            title: "HSA Savings Calculator",
            description: "Discover how much money you can save with an HSA!",
            icon: "fa-solid fa-calculator",
            url: "https://www.hsabank.com/hsabank/employer-resources/tools/HSA-savings-calculator"
        },
        rightTile: {
            title: "Additional resources",
            description: "Support your employees with additional resources that answer questions and optimize savings.",
            icon: "fa-solid fa-arrow-up-right-from-square",
            url: "https://www.hsabank.com/hsabank/partner-sites/open-enrollment/additional-resources"
        }
    },
    "AVERAGE CONTRIBUTION (YTD)": {
        title: "Optimize contributions",
        description: "These resources will help your employees optimize their contributions over time.",
        leftTile: {
            title: "HSA contribution limits",
            description: "How much can you contribute to your HSA?",
            icon: "fa-solid fa-file-pdf",
            url: "https://hsabank.bynder.com/m/fe67c09039a52414/original/HSA-Contribution-Limits.pdf"
        },
        rightTile: {
            title: "HSA contribution limits (Spanish)",
            description: "How much can you contribute to your HSA?",
            icon: "fa-solid fa-file-pdf",
            url: "https://hsabank.bynder.com/m/c2db6f3386098d48/original/HSA-Contribution-Limits-Spanish.pdf"
        }
    },
    "ZERO CONTRIBUTION ACCOUNTS (YTD)": {
        title: "Optimize zero contribution accounts",
        description: "These resources encourage contributions and will help your employees take advantage of savings opportunities over time.",
        leftTile: {
            title: "How to make individual online HSA contributions",
            description: "Learn how to contribute to your HSA.",
            icon: "fa-solid fa-file-pdf",
            url: "https://hsabank.com/HSABank/Members/How-to-use-hsa"
        },
        rightTile: {
            title: "Additional resources",
            description: "Support your employees with additional resources that answer questions and optimize savings.",
            icon: "fa-solid fa-arrow-up-right-from-square",
            url: "https://www.hsabank.com/hsabank/partner-sites/open-enrollment/additional-resources"
        }
    },
    "% OF NON PAYROLL CONTRIBUTIONS (YTD)": {
        title: "Optimize % of non payroll contributions",
        description: "These resources will help your employees take advantage of pre-tax savings which in turn lowers your payroll taxes.",
        leftTile: {
            title: "How to make individual online HSA contributions",
            description: "Learn how to contribute to your HSA.",
            icon: "fa-solid fa-file-pdf",
            url: "https://hsabank.com/HSABank/Members/How-to-use-hsa"
        },
        rightTile: {
            title: "Additional resources",
            description: "Support your employees with additional resources that answer questions and optimize savings.",
            icon: "fa-solid fa-arrow-up-right-from-square",
            url: "https://www.hsabank.com/hsabank/partner-sites/open-enrollment/additional-resources"
        }
    },
    "AVERAGE INVESTMENT BALANCE": {
        title: "Optimize average investment balance",
        description: "These resources will help your employees optimize their average investment balance over time.",
        leftTile: {
            title: "Optimize HSA investment options",
            description: "Help your employees understand the investment landscape.",
            icon: "fa-solid fa-arrow-up-right-from-square",
            url: "https://hsabank.bynder.com/m/4a90cfa0bbdff48e/original/HSA-Investment-Options.pdf"
        },
        rightTile: {
            title: "Post-enrollment resources",
            description: "Support your employees with additional resources that answer questions and optimize their accounts.",
            icon: "fa-solid fa-arrow-up-right-from-square",
            url: "https://www.hsabank.com/hsabank/partner-sites/open-enrollment/post-enrollment"
        }
    },
    "% OF INVESTORS": {
        title: "Optimize % of investors",
        description: "These resources will help your employees understand the unique advantages that HSA investing has to offer. Comprehension is the biggest barrier to investment engagement. When employees understand, they invest and grow balances more over time.",
        leftTile: {
            title: "Optimize HSA investment options",
            description: "Help your employees understand the investment landscape.",
            icon: "fa-solid fa-arrow-up-right-from-square",
            url: "https://hsabank.bynder.com/m/4a90cfa0bbdff48e/original/HSA-Investment-Options.pdf"
        },
        rightTile: {
            title: "Post-enrollment resources",
            description: "Support your employees with additional resources that answer questions and optimize their accounts.",
            icon: "fa-solid fa-arrow-up-right-from-square",
            url: "https://www.hsabank.com/hsabank/partner-sites/open-enrollment/post-enrollment"
        }
    },
    "SPENDERS VS. SAVERS (%)": {
        title: "Optimize spender saver ratio",
        description: "These resources will help your employees save more over time.",
        leftTile: {
            title: "HSAs: from safety net to nest egg",
            description: "This series of short videos demonstrate the short and long-term benefits of HSAs.",
            icon: "fa-solid fa-square-caret-right",
            url: "https://www.brainshark.com/1/player/hsabank?pi=zIJz16MyPEzavRNz0&r3f1=&fb=0"
        },
        rightTile: {
            title: "HSAs: from safety net to nest egg",
            description: "View the slide deck from the video series.",
            icon: "fa-solid fa-file-pdf",
            url: "https://hsabank.bynder.com/m/27892200d53101c/original/PDF-HSAs-From-safety-net-to-nest-egg-HSA-overview.pdf"
        }
    },
    "HEALTH CARE SPEND": {
        title: "Optimize health care spend",
        description: "These resources will help your employees understand qualified medical expenses.",
        leftTile: {
            title: "IRS rules: eligible medical expenses",
            description: "What can I use my money for?",
            icon: "fa-solid fa-file-pdf",
            url: "https://hsabank.bynder.com/m/8ba106f1c8aef94a/original/Expense-Eligibility-List.pdf"
        },
        rightTile: {
            title: "IRS rules: eligible medical expenses (Spanish)",
            description: "What can I use my money for?",
            icon: "fa-solid fa-file-pdf",
            url: "https://hsabank.bynder.com/m/facd653f1bf171ac/original/Eligible-Medical-Expenses-Spanish.pdf"
        }
    }
};